import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

export function checkboxValidator(label: string, translate: TranslateService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      let stringMsg = '';
      translate.get(['error.validation.checkbox.text', label]).subscribe((translations) => {
        stringMsg = translations['error.validation.checkbox.text'] + ' ' + translations[label];
      });
      return { notCheck: { value: control.value, msg: stringMsg } };
    }
    return null;
  };
}
